import styled from "styled-components";
import { Label, ModalButton } from "./components/AuctionStyles";

export const ProductLayout = styled.div`
  display: flex;
  gap: 22px;
  align-items: stretch;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const ProductColumn = styled.div`
  flex: 1 1 50%;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  @media (max-width: 768px) {
    flex: 1 1 100%;
    width: 100%;
  }
`;

export const VariantDeleteButton = styled.button`
  padding: 6px 8px;
  background: #dc2626;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;

  &:hover {
    background: #b91c1c;
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
`;

export const OwnerMessageBox = styled.div`
  margin-top: 8px;
  padding: 10px 16px;
  border-radius: 10px;
  background: rgba(92, 233, 255, 0.1);
  border: 1px solid rgba(92, 233, 255, 0.3);
  color: #5ce9ff;
  font-size: 13px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const DetailsHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 10px;
`;

export const DetailsTitle = styled.h3`
  margin: 0;
`;

export const DetailsButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

export const EditProductButton = styled.button`
  padding: 8px 16px;
  border-radius: 8px;
  background: rgba(92, 233, 255, 0.1);
  border: 1px solid rgba(92, 233, 255, 0.3);
  color: #5ce9ff;
  font-weight: 600;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const DeleteProductButton = styled.button`
  padding: 8px 16px;
  border-radius: 8px;
  background: ${({ $disabled }) => ($disabled ? "rgba(239, 68, 68, 0.2)" : "rgba(239, 68, 68, 0.1)")};
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: ${({ $disabled }) => ($disabled ? "#777" : "#ef4444")};
  font-weight: 600;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const FeaturesWrapper = styled.div`
  margin-top: 12px;
`;

export const FeaturesList = styled.ul`
  margin: 8px 0 0 0;
  padding-left: 20px;
  list-style: disc;
`;

export const FeatureItem = styled.li`
  margin-bottom: 4px;
  color: #e5e7eb;
`;

export const DocumentsList = styled.ul`
  padding-left: 18px;
  line-height: 26px;
  list-style: none;
`;

export const DocumentItem = styled.li`
  margin-bottom: 12px;
`;

export const DocumentLink = styled.a`
  color: #5ce9ff;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    text-decoration: underline;
    opacity: 0.9;
  }
`;

export const DocumentBullet = styled.span`
  color: #00f7d2;
`;

export const DocumentIcon = styled.span`
  color: #5ce9ff;
  font-size: 12px;
  margin-left: 4px;
`;

export const NoDocumentsText = styled.p`
  opacity: 0.7;
`;

export const SellerScoreBarWrapper = styled.div`
  margin-top: 8px;
  height: 10px;
  border-radius: 999px;
  background: #1f2937;
  overflow: hidden;
  max-width: 240px;
`;

export const SidebarHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-shrink: 0;
`;

export const SidebarTitle = styled.h3`
  margin: 0;
  color: #e5e7eb;
`;

export const SidebarCloseButton = styled.button`
  background: transparent;
  border: none;
  color: #9ca3af;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SidebarContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
`;

export const EditTextarea = styled.textarea`
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  background: #0d1220;
  border: 1px solid #1f2937;
  color: #e5e7eb;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  outline: none;

  &.description {
    min-height: 100px;
  }
  &.pickup {
    min-height: 80px;
  }
`;

export const VatHint = styled.span`
  font-size: 12px;
  color: #9ca3af;
  margin-top: 4px;
  display: block;
`;

export const EditSelect = styled.select`
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  background: #0d1220;
  border: 1px solid #1f2937;
  color: #e5e7eb;
  font-size: 14px;
  font-family: inherit;
  outline: none;
  cursor: pointer;
`;

export const FeatureRow = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
`;

export const RemoveFeatureButton = styled.button`
  padding: 8px 12px;
  border-radius: 8px;
  background: #dc2626;
  color: #fff;
  border: none;
  cursor: pointer;
  font-size: 14px;
`;

export const AddFeatureButton = styled.button`
  padding: 8px 12px;
  border-radius: 8px;
  background: #4bdfb3;
  color: #000;
  border: none;
  cursor: pointer;
  font-size: 14px;
  margin-top: 8px;
`;

export const VariantsSection = styled.div`
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #1f2937;
`;

export const VariantsSectionLabel = styled(Label)`
  margin-bottom: 12px;
  display: block;
`;

export const VariantFieldsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
`;

export const VariantFieldLabel = styled(Label)`
  font-size: 12px;
  margin-bottom: 4px;
`;

export const AddVariantButton = styled.button`
  width: 100%;
  padding: 12px 20px;
  border-radius: 8px;
  background: linear-gradient(90deg, #00f7d2, #5ce9ff);
  color: #000;
  font-weight: 700;
  border: none;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const VariantPlusSpan = styled.span`
  font-size: 16px;
`;

export const CancelEditVariantButton = styled.button`
  width: 100%;
  padding: 8px 16px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: #e5e7eb;
  font-weight: 600;
  border: 1px solid #1f2937;
  cursor: pointer;
  font-size: 12px;
  margin-top: 8px;
`;

export const VariantsTableSection = styled.div`
  margin-top: 16px;
`;

export const VariantsCountText = styled.div`
  margin-bottom: 12px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
`;

export const TableScrollWrapper = styled.div`
  overflow-x: auto;
  max-height: 300px;
  overflow-y: auto;
`;

export const VariantsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #0f1622;
  border-radius: 8px;
  overflow: hidden;
`;

export const VariantsTableHeadRow = styled.tr`
  background: #1f2937;
  border-bottom: 1px solid #374151;
`;

export const VariantsTableHeadCell = styled.th`
  padding: 10px;
  text-align: left;
  color: #e5e7eb;
  font-size: 12px;
  font-weight: 600;
  border-right: 1px solid #374151;

  &:last-child {
    border-right: none;
  }
`;

export const VariantsTableBodyRow = styled.tr`
  border-bottom: 1px solid #374151;
`;

export const VariantsTableCell = styled.td`
  padding: 10px;
  color: #e5e7eb;
  font-size: 12px;
  border-right: 1px solid #374151;

  &:last-child {
    border-right: none;
  }
`;

export const VariantsTableActionCell = styled.td`
  padding: 10px;
`;

export const ActionCellInner = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const VariantEditButton = styled.button`
  padding: 6px 8px;
  background: #4bdfb3;
  color: #000;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
`;

export const IconSmall = styled.span`
  font-size: 12px;
`;

export const SidebarFooterRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: auto;
  padding-top: 20px;
  flex-shrink: 0;
`;

export const UpdateProductButton = styled.button`
  flex: 1;
  padding: 12px 20px;
  border-radius: 10px;
  background: linear-gradient(90deg, #00f7d2, #5ce9ff);
  color: #000;
  font-weight: 700;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  border: none;
  font-size: 14px;
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
`;

export const CancelSidebarButton = styled.button`
  padding: 12px 20px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.1);
  color: #e5e7eb;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid #1f2937;
  font-size: 14px;
`;

export const AdminInput = styled.input`
  background: #0d1220;
  border: 1px solid #1f2937;
  border-radius: 8px;
  color: #e5e7eb;
  padding: 4px 8px;
  font-size: 13px;
  width: 100%;
`;

export const ModalCancelButton = styled(ModalButton)`
  background: rgba(255, 255, 255, 0.1);
  color: #e5e7eb;
`;

export const ModalDeleteButton = styled(ModalButton)`
  background: #dc2626;
  color: #fff;
`;
